export const paymentEn = {
  'payment.payments': 'Payments',
};

export const paymentEs = {
  'payment.payments': 'Pagos',
};
